import { SimpleAccordion, Accordion } from '@/components';
import { PortableText } from '@portabletext/react';
import { portableTextComponents } from '@/utils/portableTextComponents';

interface DocumentChild {
    text: string;
    _key: string;
    _type: 'span';
    marks: string[];
}

interface DocumentBlock {
    level: number;
    _type: 'block';
    style: 'normal';
    _key: string;
    listItem?: 'bullet';
    markDefs: string[];
    children: DocumentChild[];
}

interface LicenseDocuments {
    ageRestrictions: string;
    ukDrivingLicenseDocuments: DocumentBlock[];
    nonUkDrivingLicenseDocuments: DocumentBlock[];
}

const QuoteFormTermsConditions = ({
    legalContent,
}: {
    legalContent: LicenseDocuments;
}) => {
    const content = legalContent;

    const components = portableTextComponents;

    const ukDrivingLicenseDocuments = (
        <PortableText
            value={content.ukDrivingLicenseDocuments}
            components={components}
        />
    );

    const nonUkDrivingLicenseDocuments = (
        <PortableText
            value={content.nonUkDrivingLicenseDocuments}
            components={components}
        />
    );

    return (
        <SimpleAccordion
            content={
                <>
                    <Accordion
                        title="UK Driving license holders"
                        content={ukDrivingLicenseDocuments}
                    />
                    <Accordion
                        title="NON-UK Driving license holders"
                        content={nonUkDrivingLicenseDocuments}
                    />
                </>
            }
        />
    );
};

export default QuoteFormTermsConditions;
